"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const validation_1 = require("../../../utils/validation");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const errorHandling_1 = require("../../../utils/errorHandling");
const parseAndValidateInvitations = (action) => action.payload.invitations.reduce((res, row) => {
    const emails = row.emails.split(',').filter((i) => i.trim().length > 0);
    emails.forEach((e) => {
        const email = e.trim();
        (0, validation_1.isEmail)(email)(email).fold((err) => {
            const items = res.errors[row.uuid];
            if (!items) {
                res.errors[row.uuid] = err;
            }
            else {
                res.errors[row.uuid] = items.concat(err);
            }
        }, (_) => {
            res.invitations.push({
                groupId: row.group,
                email: email.trim(),
                language: row.language || 'multi'
            });
        });
    });
    return res;
}, { errors: {}, invitations: [] });
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    const processEmails = (ajax, getToken, input, baseUrl) => {
        const chunks = [];
        const invites = [...input];
        while (invites.length) {
            chunks.push(ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'POST',
                url: `${baseUrl}api/user-group/member`,
                body: invites.splice(0, 20)
            }));
        }
        return (0, rxjs_1.from)(chunks).pipe((0, operators_1.concatAll)());
    };
    function invite(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.INVITE_REQUEST), (0, operators_1.mergeMap)((action) => {
            const data = parseAndValidateInvitations(action);
            if (Object.keys(data.errors).length > 0) {
                return (0, rxjs_1.of)(Actions.inviteValidation(data.errors));
            }
            return processEmails(ajax, getToken, data.invitations, baseUrl).pipe((0, operators_1.toArray)(), (0, operators_1.mergeMap)((_) => {
                const act = [
                    Actions.inviteSuccess(),
                    ...(action.payload.actions || [])
                ];
                return (0, rxjs_1.of)(...act);
            }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.inviteFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))));
        }));
    }
    return { invite };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map